import React from "react"
import useIsWide from "src/utils/use-is-wide"
import store, { qs } from "../store"
import Tooltip from "./tooltip"

/**
 * @param props {{
 * label
 * onChange?
 * disabled?
 * onChange?
 * value?
 * labelBackground?
 * moreOptions?
 * style?
 * children?
 * width?
 * wrapperWidth?: string | number
 * size?: string
 * error?: string
 * }}
 */
export function Select(props) {
  
  var isWide = useIsWide()
  const isSmall = props.size === "small"
  
  var isOneSide=store.getView()=="oneside"

  var style = {
    fontSize: isSmall ? "0.875rem" : "1rem",
    outline: "none",
    fontWeight:700,
    flexGrow:1,
    background: "inherit",
    border: isOneSide ? 'unset': "1px solid #222",
    paddingTop: 8,
    paddingBottom: isSmall && 2,
    paddingRight: 8,
    ...(props.style || {}),
   
  }


  return (
    <div
      style={{
        position: isOneSide ?  undefined : "relative",
        width: props.wrapperWidth,
        display:isOneSide ? 'flex' : undefined,
        color: props.disabled && "#9e9e9e",
        cursor: props.disabled && "not-allowed",
      }}
    >
      {isOneSide && props.label && <div css={`
      overflow:hidden;
      text-overflow:ellipsis;
      width:110px;vertical-align:middle;flex-shrink:0;padding-top:8px;`}>
      <Tooltip tip={props.label}>
      {props.label}
      </Tooltip>
      </div>}
      {!isOneSide && props.value && <div
        style={{
          position: "absolute",
          background: props.labelBackground || "white", //rgb(246, 246, 250)
          left: 10,
          top: -10,
          fontSize: "0.75rem",
        }}
      >
        &nbsp;{props.label}&nbsp;&nbsp;
      </div>}
      <div style={style}>
        <select
          {...props}
          style={{
            background: "inherit",
            border: "none",
            width: "100%",
            fontSize: isSmall ? "0.875rem" : "1rem",
            outline: "none",
            cursor: props.disabled ? "not-allowed" : "pointer",
            minHeight: !isSmall && 40,
            paddingLeft:isOneSide ?'unset' :  8,
            marginLeft:isOneSide && props.label ? -5:'unset',
            fontWeight:isOneSide ? 700 : 400,
          }}
        >
          {props.label? <option value="">{props.label}</option>:null}
          {props.children}
        </select>
        {props.moreOptions}
      </div>
      {props.error && (
        <span  style={{
         color:'#FF0000'
        }} dangerouslySetInnerHTML={{__html: props.error}} />
      )}
    </div>
  )
}
